export default "__VITE_ASSET__38622429__"